import { api } from './api';

export const creditAmountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCreditAmountList: builder.query({
      query: () => ({ url: '/admin/credit-amount' }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'CreditAmount', id })),
              { type: 'CreditAmount', id: 'LIST' },
            ]
          : [{ type: 'CreditAmount', id: 'LIST' }],
    }),
    getCreditAmount: builder.query({
      query: (id) => ({ url: `/admin/credit-amount/${id}` }),
      providesTags: (result, error, id) => [{ type: 'CreditAmount', id }],
    }),
    createCreditAmount: builder.mutation({
      query: (body) => ({
        url: '/admin/credit-amount',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'CreditAmount', id: 'LIST' }],
    }),
    updateCreditAmount: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/credit-amount/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'CreditAmount', id },
        { type: 'CreditAmount', id: 'LIST' },
      ],
    }),
    deleteCreditAmount: builder.mutation({
      query: (id) => ({
        url: `/admin/credit-amount/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'CreditAmount', id },
        { type: 'CreditAmount', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCreditAmountListQuery,
  useGetCreditAmountQuery,
  useCreateCreditAmountMutation,
  useUpdateCreditAmountMutation,
  useDeleteCreditAmountMutation,
} = creditAmountApi;
